import deDE from './snippet/de-DE.json'
import enGB from './snippet/en-GB.json'
import nlNL from './snippet/nl-NL.json'

Shopware.Module.register('sw-product-detail-tab-upselling', {
    snippets: {
        'de-DE': deDE,
        'en-GB': enGB,
        'nl-NL': nlNL
    },

    routeMiddleware(next, currentRoute) {
        if (currentRoute.name === 'sw.product.detail') {
            currentRoute.children.push({
                name: 'sw.product.detail.upselling',
                path: '/sw/product/detail/:id/upselling',
                component: 'sw-product-detail-upselling',
                meta: {
                    parentPath: 'sw.product.index'
                }
            })
        }
        next(currentRoute)
    }
})
